(function ($) {
    $(document).ready(function () {

        var steps_cpt;
        var modalView;
        var Modal;

        wp.api.loadPromise.done(function () {
            //get steps through wp-rest api
            steps = new wp.api.collections.Steps();

        });

        $("#call-to-action").click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            sendClickToGoogle(this);

            // Create a ModalBase view class
            var ModalBase = Backbone.Modal.extend({
                template: _.template($('#modal-template').html()),
                viewContainer: '.steps-container',
                submitEl: '.done',
                cancelEl: '.cancel',
                onRender: function (e) {
                    $(".pup").fadeIn();
                },

                // Prevent modal on closing, if mouse is pressed outside of modal.
                beforeCancel: function(){
                    return false;
                },

                beforeSubmit: function (e) {
	                // Prevent modal on closing, if enter-key is pressed.
                    if(e.which === 13) {
		                return false;
	                }
                },
                onDestroy: function (e) {
                    // this.openAt(0);
                    $(".pup").fadeOut(function () {
                        $(".pup").remove();
                    });
                },
                events: {
                    'click .start': 'start',
                    'click .confirmation': 'showConfirmation',
                    'click .done': 'closeModal',
                    'click .previous': 'previousStep',
                    'click .next': 'nextStep',
                },

                start: function (e) {
                    e.preventDefault();
                    this.openAt(0);
                },
                showConfirmation: function (e) {
                    e.preventDefault();
                    this.openAt(steps.length - 1);
                },
                closeModal: function (e) {
                    e.preventDefault();
                    this.openAt(0);
                    $(".pup").fadeOut(function () {
                        $(".pup").remove();
                    });
                },
                previousStep: function (e) {
                    e.preventDefault();
                    this.previous();
                },
                nextStep: function (e) {
                    e.preventDefault();
                    this.next();
                }

            });


            //At first time, show waiting-text
            if (steps_cpt === undefined || steps_cpt.readyState === 1) {
                $("body").prepend("<div id='popbg' class='pup' style='position:fixed;width:100%;height:100%;background:#000;opacity: 0.7;z-index:2001;'></div>" +
                    "<table class=\'pup\' style='position:absolute;width:100%;height:100%;top:0;z-index:2001;'><tr><td style='vertical-align:middle;text-align:center;'>" +
                    "<div class='pop_content'>" +
                    "<h1 style='color:#fff;'>Hetkinen…</h1></div>"
                );

                //fetch steps from backbone-collection
                steps_cpt = steps.fetch({
                    data: {
                        'filter': {
                            'orderby': 'menu_order',
                            'order': 'ASC'
                        }
                    }
                }).done(function () {

                    // Create a Modal view class
                    Modal = ModalBase.extend({
                        views: generateViews(steps),
                    });

                    //Render modal
                    modalView = new Modal();
                    $('.pop_content').html(modalView.render().el);

                    //use mediaelement.js for audio,video player
                    $('video,audio').mediaelementplayer();
                });
            } else { //not first time => just render modalView
                $("body").prepend("<div id='popbg' class='pup' style='position:fixed;width:100%;height:100%;background:#000;opacity: 0.7;z-index:2001;'></div>" +
                    "<table class=\'pup\' style='position:absolute;width:100%;height:100%;top:0;z-index:2001;'><tr><td style='vertical-align:middle;text-align:center;'>" +
                    "<div class='pop_content'>" +
                    "</div>"
                );

                //Render modal
                modalView = new Modal();
                $('.pop_content').html(modalView.render().el);

                //use mediaelement.js for audio,video player
                $('video,audio').mediaelementplayer();
            }
        });
    });

})(jQuery); // Fully reference jQuery after this point.

/**
 * Helper function that send click-event to Google Analytics
 *
 * @param element
 */
function sendClickToGoogle(element) {
    var eventAction = element.dataset.id;
    var eventLabel = element.dataset.eventlabel;
    if (element.dataset.id === 'stg_element') {
        eventAction = element.dataset.id + '-show';
    }
    if (eventAction === '') {
        return;
    }
    if (eventLabel === '' || eventLabel === undefined) {
        eventLabel = eventAction;
    }
    ga('send', 'event', 'Steps', eventAction, eventLabel);
}

/**
 * Generate dynamically views for Backbone.Modal as many as there are step-cpt:s
 *
 * @param steps
 * @returns {{}}
 */
function generateViews(steps) {

    var allViews = {};

    for (var i = 1; i < steps.length; i++) {
        var oneView = new Object();

        oneView.view = _.template(function (indeksi) {
            var stepsToGod = jQuery('#valu-stg-title').html();

            var title = steps.at(indeksi).attributes.title.rendered;
            var content = steps.at(indeksi).attributes.content.rendered;
            var nextButton = steps.at(indeksi).attributes.acf.steps_buttons[0].step_next_button;
            var previousButton = steps.at(indeksi).attributes.acf.steps_buttons[0].step_previous_button;

            var progressbar = '';
            for (var ball = 0; ball < steps.length - 1; ball++) {
                if (ball < indeksi) {
                    progressbar += '<li class="active" style="width:calc(100%/' + steps.length + ')"></li>';
                } else {
                    progressbar += '<li style="width:calc(100%/' + steps.length + ')"></li>';
                }
            }

            return '<div class="bbm-modal__topbar"><h3 class="bbm-modal__title text-center">' +
                stepsToGod + '</h3></div><div class="bbm-modal__section"><h3 class="bbm-modal__title">' +
                title + '</h3><ul id="progressbar">' + progressbar + '</ul>' +
                content + '<div class="bbm-modal__bottombar">' + previousButton + nextButton +
                '</div>';
        }(i));
        allViews['click #step' + i] = oneView;
    }

    // Create last view (confirmation step, if user click no-button)
    var lastView = new Object();
    lastView.view = function () {
        var stepsToGod = jQuery('#valu-stg-title').html();
        var title = steps.at(0).attributes.title.rendered;
        var content = steps.at(0).attributes.content.rendered;
        var nextButton = steps.at(0).attributes.acf.steps_buttons[0].step_next_button;
        var previousButton = steps.at(0).attributes.acf.steps_buttons[0].step_previous_button;
        return '<div class="bbm-modal__topbar"><h3 class="bbm-modal__title text-center">' +
            stepsToGod + '</h3></div><div class="bbm-modal__section"><h3 class="bbm-modal__title">' +
            title + '</h3>' +
            content + '<div class="bbm-modal__bottombar">' + previousButton + nextButton +
            '</div>';
    };

    allViews['click #step' + steps.length] = lastView;

    return allViews;
}